import { gsap } from 'gsap'
import { CustomEase } from '../gsap/CustomEase.min.js'

gsap.registerPlugin(CustomEase)
CustomEase.create('easeOutCubic', 'M0,0 C0.33,1 0.68,1 1,1')

const menuScripts = {
    submenus: [],
    $html: $('html'),
    $window: $(window),
    $notice: $('.js-close-notice'),
    $menuToggle: $('.js-menu-mobile-toggle'),
    $menuMobile: $('.js-menu-mobile'),
    $menuBg: $('.js-menu-bg'),
    $menuUnderlay: $('.js-menu-underlay'),
    $submenuTrigger: $('.js-submenu-trigger'),
    $menuLinks: $('.js-menu-link'),
    prevScrollTop: 0,
    cachedScrollPosition: 0,
    scrollUp: false,
    menuIsHidden: false,
    isMobile: false,
    openIndexMobile: false,
    openIndexDesktop: false,
    timelineDesktop: null,
    distanceX: 20,
    distanceY: 30,
    init: function () {
        this.storeSubmenuElements()

        // Detect if user sees mobile or desktop menu
        if (this.$menuToggle.css('display') === 'block') this.isMobile = true

        //Adding custom hover effect that loads from the entering side of the mouse and unloads to the side from which the mouse exits the link
        this.$menuLinks.each((index, element) => {
            let boundaries = element.getBoundingClientRect(),
                leftBoundary = boundaries.left,
                rightBoundary = boundaries.right,
                bottomBoundary = boundaries.bottom - 12

            $(element).on('mouseenter', function (event) {
                menuScripts.loadLinkUnderline(
                    event,
                    leftBoundary,
                    rightBoundary,
                    bottomBoundary,
                    $(element)
                )
            })

            $(element).on('mouseleave', function (event) {
                menuScripts.unloadLinkUnderline(
                    event,
                    leftBoundary,
                    rightBoundary,
                    bottomBoundary,
                    $(element)
                )
            })
        })

        // Update stored state value and reset menus on resize
        this.$window.on('resize', () => {
            const isNowMobile =
                this.isMobile === false &&
                this.$menuToggle.css('display') === 'block'

            const isNowDesktop =
                this.isMobile === true &&
                this.$menuToggle.css('display') === 'none'

            if (isNowMobile) {
                if (this.openIndexDesktop > 0) {
                    let currentDesktop = this.openIndexDesktop
                    this.resetDesktopDropdowns()
                    setTimeout(function () {
                        menuScripts.$menuToggle.trigger('click')
                        menuScripts.showMobileDropdown(
                            menuScripts.submenus[currentDesktop]
                        )
                    }, 50)
                }
                this.isMobile = true
            } else if (isNowDesktop) {
                if (this.openIndexMobile > 0) {
                    let currentMobile = this.openIndexMobile
                    this.resetMobileDropdowns()
                    setTimeout(function () {
                        menuScripts.showDesktopDropdown(
                            menuScripts.submenus[currentMobile]
                        )
                    }, 50)
                }
                this.isMobile = false
            }
        })

        // Expand/collapse main mobile menu
        this.$menuToggle.on('click', () => {
            if (!this.$html.hasClass('nav-is-open')) {
                this.$html.addClass('nav-is-open')
                this.$menuMobile.slideDown()
            } else {
                this.$html.removeClass('nav-is-open')
                this.$menuMobile.slideUp()
            }
        })

        // Handle menu trigger clicks
        this.submenus.forEach(submenu => {
            submenu.$trigger.on('click', () => {
                if (this.isMobile) {
                    // Mobile behaviour
                    if (this.openIndexMobile === false) {
                        this.showMobileDropdown(submenu)
                    } else if (this.openIndexMobile === submenu.index) {
                        this.hideMobileDropdown()
                    } else {
                        this.hideMobileDropdown()
                        this.showMobileDropdown(submenu)
                    }
                } else {
                    // Desktop behaviour
                    this.resetTimelineDesktop()

                    if (this.openIndexDesktop === false) {
                        this.showDesktopDropdown(submenu)
                    } else if (this.openIndexDesktop === submenu.index) {
                        this.hideDesktopDropdown()
                    } else {
                        this.switchDesktopDropdowns(submenu)
                    }
                }
            })
        })

        // Hide desktop menu when pressing Esc key
        // or when clicking on menu underlay
        this.$menuUnderlay.on('click', () => this.hideDesktopDropdown())
        $(document).on('keyup', e => {
            if (e.key === 'Escape') this.hideDesktopDropdown()
        })

        // Show/hide menu on window scroll up/down
        this.stickyCheck(this.$window.scrollTop())
        this.$window.on('scroll', () =>
            this.stickyCheck(this.$window.scrollTop())
        )

        this.$notice.on('click', function () {
            $(this).closest('.header-notice').slideUp(240)
        })
    },
    storeSubmenuElements: function () {
        this.$submenuTrigger.map((index, trigger) => {
            const $trigger = $(trigger)
            const $wrapper = $trigger.closest('.js-menu-item')
            const menu = {
                index: $wrapper.index(),
                $trigger,
                $wrapper,
                $dropdown: $wrapper.find('.js-submenu'),
                $pages: $wrapper.find('.js-subpage-group'),
            }
            this.submenus[$wrapper.index()] = menu
        })
    },
    showMobileDropdown: function (submenu) {
        this.openIndexMobile = submenu.index
        submenu.$wrapper.addClass('is-open')
        submenu.$dropdown.slideDown()
    },
    hideMobileDropdown: function () {
        const submenu = this.submenus[this.openIndexMobile]
        this.openIndexMobile = false
        submenu.$wrapper.removeClass('is-open')
        submenu.$dropdown.slideUp()
    },
    resetMobileDropdowns: function () {
        if (this.openIndexMobile !== false) {
            const submenu = this.submenus[this.openIndexMobile]
            this.openIndexMobile = false
            submenu.$wrapper.removeClass('is-open')
            submenu.$dropdown.removeAttr('style')
        }
        if (this.$html.hasClass('nav-is-open')) {
            this.$html.removeClass('nav-is-open')
            this.$menuMobile.removeAttr('style')
        }
    },
    presetElementPosition: function (newSubmenu, direction) {
        const fromLeft = direction === 'fromLeft'
        const fromRight = direction === 'fromRight'

        gsap.set(newSubmenu.$pages, {
            x: fromRight ? this.distanceX : fromLeft ? -this.distanceX : 0,
            y: direction === 'top' ? -this.distanceY : 0,
            opacity: 0,
        })
    },
    getAnimBgObject: function (heightInPx) {
        return {
            height: heightInPx,
            duration: 0.1,
        }
    },
    getAnimPagesObject: function (action, direction = false) {
        const isClosingUp = action === 'hide' && direction === 'up'
        const fromLeft = direction === 'fromLeft'
        const fromRight = direction === 'fromRight'
        const hasDelay =
            (action === 'show' && direction === 'down') || fromLeft || fromRight

        return {
            x: fromRight ? -this.distanceX : fromLeft ? this.distanceX : 0,
            y: isClosingUp ? -this.distanceY : 0,
            opacity: action === 'show' ? 1 : 0,
            duration: 0.28,
            delay: hasDelay ? 0.2 : false,
            ease: 'easeOutCubic',
            stagger: {
                amount: 0.12,
                from: isClosingUp ? 'end' : 'start',
            },
        }
    },
    showDesktopDropdown: function (submenu) {
        this.openIndexDesktop = submenu.index

        this.timelineDesktop = gsap.timeline()
        this.timelineDesktop
            .call(() => {
                this.presetElementPosition(submenu, 'top')
                this.$menuUnderlay.fadeIn()
                submenu.$wrapper.addClass('is-open')
                submenu.$dropdown.show()
            })
            .to(
                this.$menuBg,
                this.getAnimBgObject(submenu.$dropdown.outerHeight())
            )
            .call(() => {
                this.$menuBg.addClass('has-shadow')
            })
            .to(submenu.$pages, this.getAnimPagesObject('show', 'down'))
    },
    hideDesktopDropdown: function () {
        if (this.openIndexDesktop) {
            const submenu = this.submenus[this.openIndexDesktop]
            this.openIndexDesktop = false

            this.timelineDesktop = gsap.timeline()
            this.timelineDesktop
                .to(submenu.$pages, this.getAnimPagesObject('hide', 'up'))
                .call(() => {
                    submenu.$wrapper.removeClass('is-open')
                    this.$menuBg.removeClass('has-shadow')
                })
                .to(this.$menuBg, this.getAnimBgObject(0), '-=0.28')
                .call(() => {
                    this.$menuUnderlay.fadeOut()
                    submenu.$dropdown.hide()
                    this.submenus.map(submenu =>
                        this.resetSingleDesktopDropdown(submenu)
                    )
                })
        }
    },
    switchDesktopDropdowns: function (newSubmenu) {
        const newIndex = newSubmenu.index
        const oldIndex = this.openIndexDesktop
        const oldSubmenu = this.submenus[oldIndex]

        this.openIndexDesktop = newIndex
        const direction = newIndex > oldIndex ? 'fromRight' : 'fromLeft'

        this.timelineDesktop = gsap.timeline()
        this.timelineDesktop
            .call(() => {
                this.presetElementPosition(newSubmenu, direction)
                newSubmenu.$dropdown.show()
                oldSubmenu.$wrapper.removeClass('is-open')
                newSubmenu.$wrapper.addClass('is-open')
            })
            .call(() => {
                const newHeight = newSubmenu.$dropdown.outerHeight()
                const oldHeight = oldSubmenu.$dropdown.outerHeight()
                if (newHeight > oldHeight)
                    gsap.to(this.$menuBg, this.getAnimBgObject(newHeight))
            })
            .to(oldSubmenu.$pages, this.getAnimPagesObject('hide', direction))
            .call(() => oldSubmenu.$dropdown.hide())
            .to(newSubmenu.$pages, this.getAnimPagesObject('show'), '-=0.28')
            .call(() => {
                const newHeight = newSubmenu.$dropdown.outerHeight()
                const oldHeight = oldSubmenu.$dropdown.outerHeight()
                if (newHeight < oldHeight)
                    gsap.to(this.$menuBg, this.getAnimBgObject(newHeight))
            })
    },
    resetTimelineDesktop: function () {
        if (this.timelineDesktop !== null) {
            this.timelineDesktop.pause().kill()
            this.timelineDesktop = null
        }
    },
    resetDesktopDropdowns: function () {
        if (this.openIndexDesktop !== false) {
            this.openIndexDesktop = false
            this.resetTimelineDesktop()
            this.submenus.map(submenu =>
                this.resetSingleDesktopDropdown(submenu)
            )
            this.$menuUnderlay.removeAttr('style')
            this.$menuBg.removeAttr('style').removeClass('has-shadow')
        }
    },
    resetSingleDesktopDropdown: function (submenu) {
        submenu.$wrapper.removeClass('is-open')
        submenu.$dropdown.removeAttr('style')
        submenu.$pages.removeAttr('style')
    },
    stickyCheck: function (currentScrollTop) {
        // Add class to hide main menu when scrolling down continuously
        // and add it back when scrolling back up
        if (currentScrollTop > this.prevScrollTop && this.scrollUp === true) {
            this.cachedScrollPosition = currentScrollTop
            this.scrollUp = false
        }
        if (currentScrollTop < this.prevScrollTop && this.scrollUp === false) {
            this.cachedScrollPosition = currentScrollTop
            this.scrollUp = true
        }
        if (this.scrollUp === false && this.menuIsHidden === false) {
            if (currentScrollTop > this.cachedScrollPosition + 120) {
                $('body').addClass('way-down')
                this.menuIsHidden = true

                // Reset/collapse desktop (only) menu when menu hides
                if (!this.isMobile) this.hideDesktopDropdown()
            }
        } else if (
            currentScrollTop < this.cachedScrollPosition - 80 &&
            this.menuIsHidden === true
        ) {
            $('body').removeClass('way-down')
            this.menuIsHidden = false
        }
        if (currentScrollTop < 40) {
            $('body').removeClass('way-down')
            this.menuIsHidden = false
        }

        this.prevScrollTop = currentScrollTop
    },
    loadLinkUnderline: function (event, left, right, bottom, element) {
        let coordinateX = event.clientX,
            coordinateY = event.clientY,
            leftOffset = Math.abs(left - coordinateX),
            rightOffset = Math.abs(right - coordinateX)

        //Adding class that loads the line
        if (
            coordinateY >= bottom ||
            coordinateY < 12 ||
            leftOffset < rightOffset
        ) {
            element.addClass('enter-left')
        } else if (leftOffset > rightOffset) {
            element.addClass('enter-right')
        }

        //Removing the class that unloads the line
        element.removeClass('leave-left leave-right')
    },
    unloadLinkUnderline: function (event, left, right, bottom, element) {
        let coordinateX = event.clientX,
            coordinateY = event.clientY,
            leftOffset = Math.abs(left - coordinateX),
            rightOffset = Math.abs(right - coordinateX)

        //Adding class that unloads the line
        if (
            coordinateY >= bottom ||
            coordinateY < 12 ||
            leftOffset < rightOffset
        ) {
            element.addClass('leave-left')
        } else if (leftOffset > rightOffset) {
            element.addClass('leave-right')
        }

        //Removing the class that loads the line
        element.removeClass('enter-left enter-right')
    },
}

menuScripts.init()
